import { render, staticRenderFns } from "./CorporateDirectoryDetails.vue?vue&type=template&id=f1eec762&"
import script from "./CorporateDirectoryDetails.vue?vue&type=script&lang=js&"
export * from "./CorporateDirectoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./CorporateDirectoryDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports